export default __webpack_public_path__ + "static/media/cursor.582c9081.svg";